import { render, staticRenderFns } from "./HistoryDoctor.vue?vue&type=template&id=706e2c30&scoped=true&"
import script from "./HistoryDoctor.vue?vue&type=script&lang=js&"
export * from "./HistoryDoctor.vue?vue&type=script&lang=js&"
import style0 from "./HistoryDoctor.vue?vue&type=style&index=0&id=706e2c30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e2c30",
  null
  
)

export default component.exports